import React, { useContext, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Button, Col, Container, FormGroup, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import { TransactionSimple } from "./TransactionSimple";
import "./stylesCharts.css";
import { CustomFormikMultiselect } from "src/shared/components/CustomFormikMultiselect";
import { IReactSelectOption } from "src/shared/models/ReactSelect.models";
import { notEmptyArray } from "src/shared/services/SharedService";
import { IAccountingInvoicesSearchParams } from "src/models/Accounting/AccountingReports.models";
import { ISearchParams } from "src/models/shared/ISearchParams";
import { getAllStores } from "src/services/Stores/StoreService";
import { SearchParams } from "src/shared/models/Pagination.models";
import { IChart, IChartOption } from "src/shared/models/IDashboards.models";
import { getPurchaseSectionDashboards, getInventorySectionDashboards, getAccountSectionDashboards } from "src/services/General/DashboardService";
import { RootState } from "src/store/reducers";
import { fCurrency, fCurrencyND } from "src/helpers/generalFunctions";
import { EchartDonut } from "./EchartDonut";
import ApexCharts from 'apexcharts'
import { getStoresXUser } from "src/services/Stores/FilteredStoreService";
import { getPagesAccess } from "src/store/Authentication/authSelectors";
import { setDashboardList } from "src/store/General/slices/dashboardSlice";
import spark1 from "../../assets/icons/spark1.png";
import spark2 from "../../assets/icons/spark2.png";
import spark3 from "../../assets/icons/spark3.png";
import spark4 from "../../assets/icons/spark4.png";
import spark21 from "../../assets/icons/spark21.png";
import spark22 from "../../assets/icons/spark22.png";
import spark23 from "../../assets/icons/spark23.png";
import spark24 from "../../assets/icons/spark24.png";
import sales from "../../assets/icons/sales.png";
import { TransactionTitleValue } from "./TransactionTitleValue";
import { EchartPie } from "./EchartPie";
import { EchartBasicBarHorizontal } from "./EchartBasicBarHorizontal";
import { EchartBasicBar } from "./EchartBasicBar";
import { TableForDashboard } from "./TableForDashboard";
import { TableForDashboardLowInv } from "./TableForDashboardLowInv";
import { TableForDashboardAcc } from "./TableForDashboardAcc";
import { RefsContext } from "src/contexts/OnboardingContext";

var initialSearchState:IAccountingInvoicesSearchParams = {
  startDate: new Date(),
  endDate: new Date(),
  posId: 30,
  storeId: null,
};
interface IChartsInfo {
  tabId: number;
  posId: number;
  info: IChart| null;
}

const Dashboard = () => {
  const refsContext = useContext(RefsContext);

  if (!refsContext) {
    return null; // O maneja el caso donde el contexto no está disponible
  }
  const { tooltip1 } = refsContext;
  const tabStylesActive = {
    borderBottomWidth: "2px",
    borderRadius: 0,
    borderBottomColor: "#2196F3",
    borderBottomStyle: "solid",
    color: "#2196F3"
  } 
  
  const tabStyles = {
    color: "#A1A5B7"
  };

  const getTabStyles = (isActive) => {
    return isActive ? tabStylesActive : tabStyles;
  };
  const dispatch = useDispatch();
  const [activeTab, setactiveTab] = useState("1");
  const [period, setPeriod] = useState(30);
  const [searchParams, setSearchParams] = useState<IAccountingInvoicesSearchParams>(initialSearchState); 
  const [storeDataSelect, setStoreDataSelect] = useState<IReactSelectOption[]>([]);
  const [consultedDashboards, setConsultedDashboards] = useState<IChartsInfo[]>([]);
  const [loadingDataSelect, setLoadingDataSelect] = useState(false);
  const [loading, setLoading] = useState(false);
  const pagesAccess = useSelector(getPagesAccess());
  const pagesAccessURLS: string[] =  pagesAccess?.map((page: any) => page.pageURL) || [];
  
  const [searchNoResults, setSearchNoResults] = useState<SearchParams>({
    searchParams: "",
    page: 1,
    noResults: false,
  });
  
  const {
    general: {
      dashboard: { dashboards },
    },
    stores: {
      store: { stores },
      filteredStore: { filteredStores },
    },
  } = useSelector((state: RootState) => state);
  const userStores = useSelector((state: RootState) => state.auth.user?.stores) ?? [];

  useEffect(() => {
    setLoading(true)
    if(pagesAccessURLS?.includes("/dashboard"))
      getDataFromApi({ searchParam: null as any } as ISearchParams);
    
    setLoading(false)

    return () => {
      setactiveTab(null as any);
      setPeriod(null as any);
      setSearchParams(null as any)
    };
  }, []);

  useEffect(() => {
    changeStores();
  }, [filteredStores]);

  const changeStores = () => {
    if(!pagesAccessURLS?.includes("/dashboard")) return

    setLoadingDataSelect(true)
    var storesIds = filteredStores?.map((x) => x.storeId) ?? getStoresXUser();
    if(storesIds.length == 0) storesIds = userStores;
    
    const dataD = storesIds.length > 0 ? 
    stores.filter((x) => storesIds.includes(x.storeId)).map((item) => {
      return {
        value: item.storeId,
        label: item.name,
      };
    })
    : [];
    setStoreDataSelect(dataD);
    setLoadingDataSelect(false)
  }

  const getDataFromApi = async (model: ISearchParams) => {
    setLoadingDataSelect(true);
    setSearchNoResults(null as any);
    try {
      const responseStores = await getAllStores(dispatch);
      var storesIds = filteredStores?.map((x) => x.storeId) ?? getStoresXUser();
      if(storesIds.length == 0) storesIds = userStores;
      if (responseStores.data && responseStores.data.length > 0 && storesIds.length > 0) {
        const dataS = storesIds.length > 0 ? 
          responseStores.data.filter(x => storesIds.includes(x.storeId)).map((item: any) => {
            return {
              value: item.storeId,
              label: item.name,
            };
          })
          : responseStores.data.map((item: any) => {
            return {
              value: item.storeId,
              label: item.code + " - " + item.name,
            };
          });
        setStoreDataSelect(dataS);
      }
    } catch (error) {
    } finally {
      setLoadingDataSelect(false);
    }
  };

  useEffect(() => {
    // ------------------------------------- HEADERS
    const loadData = () => {
      if(activeTab == "1")
      {
        // if(dashboards?.header?.every(z => z.value == 0))
        //   return
        dashboards?.header?.forEach((item: any, index: number) => {
            const headers = {
              chart: {
                id: `sparkline${index}`,
                group: 'sparklines',
                type: 'area',
                height: 95,
                sparkline: {
                  enabled: true
                },
              },
              stroke: {
                curve: 'straight'
              },
              fill: {
                opacity: 1,
              },
              series: [{
                name: item.title,
                data: []
              }],
              labels: [],
              yaxis: {
                min: 0
              },
              xaxis: {
                type: 'datetime',
              },
              colors: ['#DCE6EC'],
              title: {
                text: item.title,
                align: "left",
                offsetX: 0,
                style: {
                  fontSize: '16px',
                  fontFamily: 'Open Sans,sans-serif',
                  cssClass: 'apexcharts-yaxis-title',
                  fontWeight: "bold"
                }
              },
              subtitle: {
                text: item.valueSymbol != "" ? `${item.valueSymbol} ${fCurrency(item.value)}` : `${fCurrencyND(item.value)}`,
                offsetX: 0,
                align: "left",
                style: {
                  fontSize: '18px',
                  color: index == 0 ? "#2196F3" : index == 1 ? "#8FD44A" : index == 2 ? "#00C1B5" : "#FFB74D",
                  fontFamily: 'Open Sans,sans-serif',
                  cssClass: 'apexcharts-yaxis-title',
                  fontWeight: "bold"
                }
              }
          }
          new ApexCharts(document.querySelector(`#spark${index + 1}`), headers).render();
        });
      }
      else if(activeTab == "2")
      {
        // if(dashboards?.header?.every(z => z.value == 0))
        //   return
        dashboards?.header?.forEach((item: any, index: number) => {
            const headers = {
              chart: {
                id: `sparkline${index}`,
                group: 'sparklines',
                type: 'area',
                height: 95,
                sparkline: {
                  enabled: true
                },
              },
              stroke: {
                curve: 'straight'
              },
              fill: {
                opacity: 1,
              },
              series: [{
                name: item.title,
                data: []
              }],
              labels: [],
              yaxis: {
                min: 0
              },
              xaxis: {
                type: 'datetime',
              },
              colors: ['#DCE6EC'],
              title: {
                text: item.title,
                offsetX: 0,
                align: "left",
                style: {
                  //open sans
                  fontFamily: 'Open Sans,sans-serif',
                  fontSize: '14px',
                  cssClass: 'apexcharts-yaxis-title',
                  fontWeight: "bold",
                  whiteSpace: 'normal', // Permitir ajuste de texto
                  wordWrap: 'break-word' // Ajustar palabras largas
                }
              },
              subtitle: {
                text: item.valueSymbol != "" ? `${item.valueSymbol} ${fCurrency(item.value)}` : `${fCurrencyND(item.value)}`,
                offsetX: 0,
                align: "left",
                style: {
                  fontFamily: 'Open Sans,sans-serif',
                  fontSize: '18px',
                  fontWeight: "bold",
                  color: index == 0 ? "#2196F3" : index == 1 ? "#8FD44A" : index == 2 ? "#00C1B5" : "#FFB74D",
                  cssClass: 'apexcharts-yaxis-title',
                }
              }
          }
          new ApexCharts(document.querySelector(`#spark2${index + 1}`), headers).render();
        });
      }
      else if(activeTab == "3")
      {
        // if(dashboards?.header?.every(z => z.value == 0))
        //   return
        dashboards?.header?.forEach((item: any, index: number) => {
            const headers = {
              chart: {
                id: `sparkline${index}`,
                group: 'sparklines',
                type: 'area',
                height: 95,
                sparkline: {
                  enabled: true
                },
              },
              stroke: {
                curve: 'straight'
              },
              fill: {
                opacity: 1,
              },
              series: [{
                name: item.title,
                data: []
              }],
              labels: [],
              yaxis: {
                min: 0
              },
              xaxis: {
                type: 'datetime',
              },
              colors: ['#DCE6EC'],
              title: {
                text: item.title,
                offsetX: 0,
                align: "left",
                style: {
                  fontFamily: 'Open Sans,sans-serif',
                  cssClass: 'apexcharts-yaxis-title',
                  fontSize: '14px',
                }
              },
              subtitle: {
                text: item.valueSymbol != "" ? `${item.valueSymbol} ${fCurrency(item.value)}` : `${fCurrencyND(item.value)}`,
                offsetX: 0,
                align: "left",
                style: {
                  fontFamily: 'Open Sans,sans-serif',
                  fontSize: '14px',
                  fontWeight: "bold",
                  color: index == 0 ? "#2196F3" : index == 1 ? "#8FD44A" : index == 2 ? "#00C1B5" : "#FFB74D",
                  cssClass: 'apexcharts-yaxis-title'
                }
              }
          }
          new ApexCharts(document.querySelector(`#spark3${index + 1}`), headers).render();
        });
      }
    };

    if(dashboards && !loading && pagesAccessURLS?.includes("/dashboard"))
      loadData();
    
  }, [dashboards, loading]);

  useEffect(() => {
    loadData();
  }, [activeTab, period]);
  
  const loadData = async (comesFromApply:boolean = false) => {
    setLoading(true)
    var lookUp = searchParams.posId != 1
    var infoIndx = consultedDashboards.findIndex(x => x.tabId.toString() == activeTab && searchParams.posId == x.posId)
    if(activeTab == "1")
    {
      if(lookUp && (!comesFromApply && infoIndx != -1))
        dispatch(setDashboardList(consultedDashboards[infoIndx].info))
      else{
        var res = await getPurchaseSectionDashboards(dispatch, searchParams);
        if(res.success && lookUp){
          // Agregar response a consultedDashboards
          if(consultedDashboards.length > 0)
            setConsultedDashboards([...consultedDashboards, {tabId: Number(activeTab), posId: searchParams.posId || 0, info: res.data}])
          else  
            setConsultedDashboards([{tabId: Number(activeTab), posId: searchParams.posId || 0, info: res.data}])
        }
      }
    }
    else if(activeTab == "2")
    {
      if(lookUp && (!comesFromApply && infoIndx != -1))
        dispatch(setDashboardList(consultedDashboards[infoIndx].info))
      else{
        var res = await getInventorySectionDashboards(dispatch, searchParams);
        if(res.success && lookUp){
          // Agregar response a consultedDashboards
          if(consultedDashboards.length > 0)
            setConsultedDashboards([...consultedDashboards, {tabId: Number(activeTab), posId: searchParams.posId || 0, info: res.data}])
          else  
            setConsultedDashboards([{tabId: Number(activeTab), posId: searchParams.posId || 0, info: res.data}])
        }
      }
    }
    else if(activeTab == "3")
    {
      if(lookUp && (!comesFromApply && infoIndx != -1))
        dispatch(setDashboardList(consultedDashboards[infoIndx].info))
      else{
        var res = await getAccountSectionDashboards(dispatch, searchParams);
        if(res.success && lookUp){
          // Agregar response a consultedDashboards
          if(consultedDashboards.length > 0)
            setConsultedDashboards([...consultedDashboards, {tabId: Number(activeTab), posId: searchParams.posId || 0, info: res.data}])
          else  
            setConsultedDashboards([{tabId: Number(activeTab), posId: searchParams.posId || 0, info: res.data}])
        }
      }
    }
      
    setLoading(false)
  }

  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const initMultiSelectDefaultValues = (
    initValues: number[],
    selectDataOption: IReactSelectOption[]
  ): IReactSelectOption[] => {
    const selectedOptions = initValues.map(v => {
      let option = selectDataOption.find(opt => opt.value === v);
      if (option) return option;
    });

    return selectedOptions.filter(notEmptyArray);
  };

  function handleSetFieldValue(field: string, value: any, shouldValidate?: boolean | undefined): void {
    setSearchParams({
      ...searchParams,
      [field]: value,
    });
  }
  
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard | DualCloud ERP</title>
        </MetaTags>
        <Container fluid>
          {
            (pagesAccessURLS?.includes("/dashboard"))?
            <>
              <Breadcrumbs title="Dashboard" breadcrumbItem="Dashboard" />
              <div className="row mt-4" ref={tooltip1}>
                <Col lg="4" className="mt-1">
                  <Row>
                    <Col sm="12">
                    <FormGroup className="">
                      {/* <h5 className="card-title me-2">Filtros</h5> */}
                      <CustomFormikMultiselect
                        fieldName={"storeId"}
                        label="Sucursal"
                        options={
                          storeDataSelect?.length > 0
                            ? storeDataSelect
                            : []
                        }
                        defaultValues={initMultiSelectDefaultValues(
                          searchParams?.storeId || [],
                          storeDataSelect?.length > 0
                            ? storeDataSelect
                            : []
                        )}
                        setFieldValue={handleSetFieldValue}
                        loading={loading || loadingDataSelect}
                        loadingOptions={loadingDataSelect}
                      />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Col lg="5" className="d-flex flex-wrap align-items-center mt-0" >
                  <div className="center mt-0">
                    <FormGroup style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <Label htmlFor={"todayrange"} className="form-label mb-1">
                        Rango de tiempo
                      </Label>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <button id={"todayrange"} type="button" className={`btn btn-outline-secondary shadow-none ${period == 1 ? "btn-primary " : "" } btn-sm ml-2 `} style={{ marginRight: "10px" }} onClick={() => { setSearchParams({ ...searchParams, posId: 1 }), setPeriod(1) }}>
                          Hoy
                        </button>
                        <button type="button" className={`btn btn-outline-secondary shadow-none ${period == 7 ? "btn-primary" : ""} btn-sm ml-2`} style={{ marginRight: "10px" }} onClick={() => { setSearchParams({ ...searchParams, posId: 7 }), setPeriod(7) }}>
                          Esta semana
                        </button>
                        <button type="button" className={`btn btn-outline-secondary shadow-none ${period == 15 ? "btn-primary" : ""} btn-sm ml-2`} style={{ marginRight: "10px" }} onClick={() => { setSearchParams({ ...searchParams, posId: 15 }), setPeriod(15) }}>
                          Últimos 15 días
                        </button>
                        <button type="button" className={`btn btn-outline-secondary shadow-none ${period == 30 ? "btn-primary" : ""} btn-sm ml-2`} style={{ marginRight: "10px" }} onClick={() => { setSearchParams({ ...searchParams, posId: 30 }), setPeriod(30) }}>
                          Últimos 30 días
                        </button>
                        {/* <button
                          type="button"
                          disabled={loading}
                          onClick={() => {
                            loadData(true);
                          }}
                          style={{ marginRight: "10px" }}
                          className="btn btn-sm shadow-none btn-primary shadow-none waves-effect waves-light ml-2"
                        >
                          Aplicar filtros
                        </button>
                        <button 
                          type="button"
                          disabled={loading}
                          onClick={() => {
                            setSearchParams(initialSearchState);
                          }}
                          className="btn btn-sm btn-outline-primary shadow-none waves-effect waves-light ml-2"
                        >
                          Restablecer
                      </button> */}
                      </div>
                    </FormGroup>
                    </div>
                </Col>

                <Col lg="3" className="d-flex flex-wrap align-items-center mt-0" style={{ alignContent: "flex-start", justifyContent: "flex-end" }} >
                  <div className="center mt-1">
                  <Label htmlFor={"todayrangex"} className="form-label mb-1">
                    &nbsp;
                    </Label>
                    <FormGroup style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>                     
                      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end'  }}>
                        <button
                          type="button"
                          disabled={loading}
                          onClick={() => {
                            loadData(true);
                          }}
                          style={{ marginRight: "10px" }}
                          className="btn btn-sm shadow-none btn-primary shadow-none waves-effect waves-light ml-2"
                        >
                          Aplicar filtros
                        </button>
                        <button 
                          type="button"
                          disabled={loading}
                          onClick={() => {
                            setSearchParams(initialSearchState);
                          }}
                          className="btn btn-sm btn-outline-primary shadow-none waves-effect waves-light ml-2"
                        >
                          Restablecer
                      </button>
                      </div>
                    </FormGroup>
                  </div>
                </Col>
              </div>
              <Row className="mt-4 mb-4">
                <Col lg="12">
                  <Nav tabs className="nav nav-pills mb-4" style={{borderBottom: "1px solid #D1CDCD"}}>
                    <NavItem >
                      <NavLink
                        style={{ cursor: "pointer", textAlign: "center",  backgroundColor: "#fff",  ...getTabStyles(activeTab === "1")}}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        Ventas
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer", textAlign: "center",  backgroundColor: "#fff",  ...getTabStyles(activeTab === "2")}}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        Inventarios
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer", textAlign: "center",  backgroundColor: "#fff",  ...getTabStyles(activeTab === "3")}}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        Contabilidad
                      </NavLink>
                    </NavItem>
                  </Nav>
                  {
                    loading ?
                    <React.Fragment>
                      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px'}}>
                        <div className="loader-new"></div>
                      </div>
                    </React.Fragment>
                    : 
                    // Si no hay datos en ningun header mostrar NO HAY REGISTROS
                    // dashboards?.header?.every(z => z.value == 0) ?
                    // <React.Fragment>
                    //   <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px'}}>
                    //     <h4 color="#00214C">NO HAY REGISTROS DISPONIBLES</h4>
                    //   </div>
                    // </React.Fragment>
                    // :
                      <TabContent activeTab={activeTab} className="p-3 text-muted">
                        <TabPane tabId="1">
                          {/* <HeaderRowInfo /> */}
                          <Row className="mb-5">
                            <Col sm={activeTab == "3" ? 4 : 3} >
                              <div className="row sparkboxes pe-0 me-4" >
                                  <div className="box box1">
                                    <div id="spark1"></div>
                                    <img width="50px" style={{marginRight:"10px"}} height={"auto"} src={spark1} alt="iconspark1" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            <Col sm={activeTab == "3" ? 4 : 3} >
                              <div className="row sparkboxes pe-0 me-4">
                                  <div className="box box1">
                                    <div id="spark2"></div>
                                    <img width="50px" style={{marginRight:"10px"}} height={"auto"} src={spark2} alt="iconspark2" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            <Col sm={activeTab == "3" ? 4 : 3}>
                              <div className={`${activeTab == "3" ? 'row sparkboxes' : 'row sparkboxes pe-0 me-4'}`}>
                                  <div className="box box1">
                                    <div id="spark3"></div>
                                    <img width="50px" style={{marginRight:"10px"}} height={"auto"} src={spark3} alt="iconspark3" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            {
                              activeTab != "3" &&
                              <Col sm={3}>
                                <div className="row sparkboxes pe-2 ">
                                    <div className="box box1">
                                      <div id="spark4"></div>
                                      <img width="50px" style={{marginRight:"10px",marginLeft:"10px"}} height={"auto"} src={spark4} alt="iconspark4" className="chart-icon" />
                                    </div>
                                </div>
                              </Col>
                            }
                          </Row>
                          <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: "3rem" }}>                        
                            <Col sm={3} style={{ flex: '0 0 27%', maxWidth: '27%',padding: 0 }}>
                              <TransactionTitleValue details={dashboards?.table ?? []} srcImage={sales} tableTitle={"Ventas por sucursal"} tabId={Number(activeTab)} />
                            </Col>
                            {/* Graficos */}                       
                            <Col className="shadowCard" sm={6} style={{ flex: '0 0 41%', maxWidth: '41%' }}>
                              <EchartBasicBar titleChart={"Ventas por mes"} details={dashboards?.charts[6] as IChartOption} titleChartNoData={"las ventas por mes"} />
                            </Col>
                            <Col className="shadowCard" sm={3} style={{ flex: '0 0 27%', maxWidth: '27%' }}>
                              <EchartDonut titleChart={"Forma de pago"} titleChartNoData={"las formas de pago"} details={dashboards?.charts[1] as IChartOption} />
                            </Col>
                          </Row>
                          {/* Graficos */}
                          <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: "3rem" }}>           
                            <Col sm={4} className="shadowCard"  style={{ flex: '0 0 35%', maxWidth: '35%' }} >
                              <EchartDonut titleChart={"Tipo de venta"} titleChartNoData={"los tipos de venta"} details={dashboards?.charts[0] as IChartOption} />
                            </Col>
                            <Col sm={4} className="shadowCard"  style={{ flex: '0 0 35%', maxWidth: '35%' }} >
                              <EchartDonut titleChart={"Facturas"} titleChartNoData={"facturas"} details={dashboards?.charts[3] as IChartOption} />
                            </Col>
                            <Col sm={4} className="shadowCard"  style={{ flex: '0 0 25%', maxWidth: '25%', paddingLeft:'0 !important', paddingRight:'0 !important' }} >
                              <EchartPie titleChart={"Cotizaciones"} titleChartNoData={"cotizaciones"} details={dashboards?.charts[4] as IChartOption}/>
                            </Col>
                          </Row>
                          <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: "3rem" }}>                        
                            <Col sm={5} className="shadowCard"  style={{ flex: '0 0 52%', maxWidth: '52%' }} >
                              <EchartBasicBarHorizontal  titleChart={"Top productos vendidos"} titleChartNoData={"top productos más vendidos"} details={dashboards?.charts[5] as IChartOption} />
                            </Col>
                            <Col sm={7} className="shadowCard"  style={{ flex: '0 0 45%', maxWidth: '45%', paddingLeft: 0, paddingRight: 0 }} >
                              <TableForDashboard titleChartNoData={"top ventas por cliente"} tableTitle={"Top ventas por cliente"} details={dashboards?.topSalesByClient ?? []} />
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="2">
                          <Row className="mb-3">
                            <Col sm={activeTab == "3" ? 4 : 3} >
                              <div className="row sparkboxes pe-0 me-4" >
                                  <div className="box box1">
                                    <div id="spark21"></div>
                                    <img width="50px"  style={{marginRight:"10px"}} height={"auto"} src={spark21} alt="iconspark21" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            <Col sm={activeTab == "3" ? 4 : 3}>
                              <div className="row sparkboxes pe-0 me-4" >
                                  <div className="box box1">
                                    <div id="spark22"></div>
                                    <img width="50px"  style={{marginRight:"10px"}} height={"auto"} src={spark22} alt="iconspark22" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            <Col sm={activeTab == "3" ? 4 : 3}>
                              <div className={`${activeTab == "3" ? 'row sparkboxes' : 'row sparkboxes pe-0 me-4'}`} >
                                  <div className="box box1">
                                    <div id="spark23"></div>
                                    <img width="50px"  style={{marginRight:"10px"}} height={"auto"} src={spark23} alt="iconspark23" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            {
                              activeTab != "3" &&
                              <Col sm={3}>
                                <div className="row sparkboxes pe-2" >
                                    <div className="box box1">
                                      <div id="spark24"></div>
                                      <img width="50px" style={{marginRight:"10px",marginLeft:"10px"}} height={"auto"} src={spark24} alt="iconspark24" className="chart-icon" />
                                    </div>
                                </div>
                              </Col>
                            }
                          </Row>
                          <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: "3rem" }}>        
                            <Col className="shadowCard" sm={5} style={{ flex: '0 0 42%', maxWidth: '42%' }}>
                              <EchartBasicBar  titleChart={"Valor de inventario por sucursal"} details={dashboards?.charts[2] as IChartOption} mixColors={true} titleChartNoData={"valor de inventario por sucursal"} />
                            </Col>
                            <Col className="shadowCard" sm={7} style={{ flex: '0 0 55%', maxWidth: '55%' }}>
                              <EchartBasicBar  titleChart={"Valor de inventario por grupo de producto"} details={dashboards?.charts[3] as IChartOption} titleChartNoData={"valor de inventario por grupo de producto"} />
                            </Col>
                          </Row>

                          <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: "3rem" }}>                        
                            <Col sm={5} className="shadowCard"  style={{ flex: '0 0 35%', maxWidth: '35%' }} >
                              <EchartDonut  titleChart={"Entradas de producto"} titleChartNoData={"las entradas de producto"} details={dashboards?.charts[0] as IChartOption} />
                            </Col>
                            <Col sm={7} className="shadowCard"  style={{ flex: '0 0 35%', maxWidth: '35%' }} >
                              <EchartDonut  titleChart={"Salidas de producto"} titleChartNoData={"las salidas de producto"} details={dashboards?.charts[1] as IChartOption} />
                            </Col>
                            <Col sm={4} className="shadowCard"  style={{ flex: '0 0 25%', maxWidth: '25%', paddingLeft:'0 !important', paddingRight:'0 !important' }} >
                              <EchartPie  titleChart={"Productos con inventario crítico"} titleChartNoData={"productos con inventario crítico"} details={dashboards?.charts[5] as IChartOption}/>
                            </Col>
                          </Row>

                          <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: "3rem" }}>                        
                            <Col sm={5} className="shadowCard"  style={{ flex: '0 0 52%', maxWidth: '52%' }} >
                              <EchartBasicBarHorizontal  titleChart={"Inventario de  productos más vendidos"} titleChartNoData={"inventario de los productos más vendidos"} details={dashboards?.charts[4] as IChartOption} />
                            </Col>
                            <Col sm={7} className="shadowCard"  style={{ flex: '0 0 45%', maxWidth: '45%', paddingLeft: 0, paddingRight: 0 }} >
                              <TableForDashboardLowInv details={dashboards?.lowInvProduct ?? []} tableTitle={"Productos con inventario bajo"} titleChartNoData={"productos con inventario bajo"} />
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="3">
                          <Row className="mb-3">
                            <Col sm={activeTab == "3" ? 4 : 3} >
                              <div className="row sparkboxes pe-0 me-4">
                                  <div className="box box1">
                                    <div id="spark31"></div>
                                    <img width="50px" style={{marginRight:"10px"}} height={"auto"} src={spark24} alt="iconspark24" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            <Col sm={activeTab == "3" ? 4 : 3}>
                              <div className="row sparkboxes pe-0 me-4">
                                  <div className="box box1">
                                    <div id="spark32"></div>
                                    <img width="50px" style={{marginRight:"10px"}} height={"auto"} src={spark2} alt="iconspark2" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                            <Col sm={activeTab == "3" ? 4 : 3}>
                              <div className="row sparkboxes pe-2">
                                  <div className="box box1">
                                    <div id="spark33"></div>
                                    <img width="50px" style={{marginRight:"10px",marginLeft:"10px"}} height={"auto"} src={spark1} alt="iconspark1" className="chart-icon" />
                                  </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mt-1">                        
                            <Col sm={12} className="shadowCard"  style={{ flex: '0 0 100%', maxWidth: '100%', paddingLeft: 0, paddingRight: 0, marginTop: '3rem' }}><TableForDashboardAcc details={dashboards?.table ?? []} tableTitle="Contabilidad" titleChartNoData={"los registros de contabilidad"} /></Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                  }
                </Col>
              </Row>
            </> :
            <Breadcrumbs title="Bienvenido" breadcrumbItem="DualCloud ERP" />
          }
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;